import React from "react"

import { AirtableApi } from "../../helpers/AirtableApi"

import * as scoresStyles from "../../styles/world_championships/Scores.module.css"

const Scores = props => {
  const [scores, setScores] = React.useState(null)
  const [hasError, setHasError] = React.useState(false)

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await AirtableApi.readRecords(
          process.env.GATSBY_AIRTABLE_API_TOKEN,
          `appoE3nlX6zL5jsX4`,
          `Scores`,
          `score`,
          `desc`,
        )

        setScores(data.records)
      } catch (error) {
        console.error(error)

        setHasError(true)
      }
    }
    if (!scores) fetchData()
  }, [scores])

  return (
    <div className="container-fluid p-0">
      <div className={`row g-0 ${scoresStyles.wrapper}`}>
        <div className="col-12">
          <div className={`row g-0 ${scoresStyles.contentWrapper}`}>
            <div className={`col-12 ${scoresStyles.content}`}>
              <div class="container-fluid p-0">
                <div className={`row g-0 ${scoresStyles.titleRow}`}>
                  <div className={`col-12 ${scoresStyles.title}`}>
                    Quiz Scores
                  </div>
                </div>
                <div className={`row g-0 ${scoresStyles.errorRow}`}>
                  <div className={`col-12 ${scoresStyles.errorMessage}`}>
                    {hasError && (
                      <p>
                        An unexpected error has occurred. Please confirm all
                        data to be correctly input and try again...
                      </p>
                    )}
                  </div>
                </div>
                <div className={`row g-0 ${scoresStyles.headerRow}`}>
                  <div className={`col-2 ${scoresStyles.header}`}>Rank</div>
                  <div className={`col-5 ${scoresStyles.header}`}>Name</div>
                  <div className={`col-4 ${scoresStyles.header}`}>Country</div>
                  <div className={`col-1 ${scoresStyles.header}`}>Score</div>
                </div>
                {scores &&
                  scores.map((record, index) => (
                    <div
                      key={index}
                      className={`row g-0 ${scoresStyles.scoreRow}`}
                    >
                      <div className={`col-2 ${scoresStyles.rank}`}>
                        #{index + 1}
                      </div>
                      <div className={`col-5 ${scoresStyles.name}`}>
                        {record.name}
                      </div>
                      <div className={`col-4 ${scoresStyles.country}`}>
                        {record.country}
                      </div>
                      <div className={`col-1 ${scoresStyles.score}`}>
                        {record.score}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Scores
